import PropTypes from 'prop-types';
import React, { useState } from 'react';
import Head from 'next/head';
import Button from '@components/Shared/Buttons/Button';

import { padItems } from '@utils/formatters';
import { getNewsMentions } from '@services/newsroomService';

import ScrollUpButtonContainer from '@components/Shared/ScrollUpButton/ScrollUpButtonContainer';
import Hero from '@components/Newsroom/Hero/Hero';
import NewsMentionCard from '@components/Newsroom/NewsMentionCard/NewsMentionCard';
import ClaytonLogo from '@components/Shared/ClaytonLogo/ClaytonLogo';
import NewsMentionsStyles from './NewsMentions.styled';

const CARDS_PER_VIEW = 14;

const NewsMentions = ({ ssrNewsMentions }) => {
  const [newsViewCount, setNewsViewCount] = useState(CARDS_PER_VIEW);
  const [newsMentions, setNewsMentions] = useState(ssrNewsMentions || []);

  if (!newsMentions) {
    getNewsMentions()
      .then((result) => {
        setNewsMentions(result);
      })
      .catch();
  }

  return (
    <div className="constrained-width-newsroom">
      <NewsMentionsStyles>
        <Head>
          <title>In the News | Clayton Newsroom</title>
          <meta
            name="description"
            content="Read more about how Clayton is innovating the home building industry to help hard working American families attain homeownership."
          />
          <meta property="og:image" content={ClaytonLogo} />
        </Head>
        <Hero>In the News</Hero>
        <ScrollUpButtonContainer />
        <div className="news-section">
          <div className="news-cards">
            {newsMentions && newsMentions.length > 0 ? (
              newsMentions.slice(0, newsViewCount).map((newsMention, index) => {
                return (
                  <NewsMentionCard
                    key={`news-${index}`}
                    newsMention={newsMention}
                  />
                );
              })
            ) : (
              <p>No results found to match your search.</p>
            )}
            {padItems(newsMentions, 2)}
          </div>
        </div>
        {newsMentions.length > newsViewCount ? (
          <div className="news-actions">
            <Button
              className="gtm-load-more"
              onClick={(e) => {
                setNewsViewCount(newsViewCount + CARDS_PER_VIEW);
                e.target.blur();
              }}
              buttonStyle="outlined"
            >
              LOAD MORE
            </Button>
          </div>
        ) : null}
      </NewsMentionsStyles>
    </div>
  );
};

NewsMentions.propTypes = {
  ssrNewsMentions: PropTypes.array,
};

//eslint-disable-next-line no-unused-vars
export async function getServerSideProps() {
  let ssrNewsMentions = null;

  await getNewsMentions()
    .then((result) => {
      ssrNewsMentions = result;
    })
    .catch((error) => {
      console.error(`Error retrieving getNewsMentions: ${error}`);
    });

  return {
    props: {
      ssrNewsMentions,
    },
  };
}

export default NewsMentions;
